export interface UnsubscribedEmailRequestModel {
  reason: string;
}
